<template>
  <div class="customer">
    <v-container class="my-5">
      <v-row justify="center">
        <v-col>
          <ShowCustomer v-if="customer && !editMode" :propCustomer="customer" @editMode="editMode = !editMode" />
          <EditCustomer v-if="customer && editMode" :propCustomer="customer" @editMode="editMode = !editMode" @closeEdit="closeEdit" />
          <span v-if="!customer">No customer with that ID</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <ItemsTable v-if="customer && !editMode" :propHeaders="customerItemsHeaders" :propItems="customer.Items" :propShowExpand="true" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import ShowCustomer from '@/components/ShowCustomer'
import EditCustomer from '@/components/EditCustomer'
import ItemsTable from '@/components/ItemsTable'

export default {
  name: 'Customer',

  components: {
    ShowCustomer,
    EditCustomer,
    ItemsTable
  },

  data: () => ({
    customer: null,
    editMode: false,
    customerItemsHeaders: [
      { text: 'Serial Number', value: 'serialNumber' },
      { text: 'Casing ID', value: 'casingId' }
    ]
  }),

  mounted () {
    this.getCustomerById(this.$route.params.customerId)
  },

  methods: {
    async getCustomerById (customerId) {
      let result
      try {
        result = await axios.get(process.env.VUE_APP_API_URL + '/customer/' + customerId)
      } catch (err) {
        console.error('Error trying to getCustomerById axios.get()', err)
      }

      this.customer = result.data
    },

    closeEdit () {
      this.editMode = false
      this.getCustomerById(this.customer.id)
    }
  }
}
</script>
